import { useQuery } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useRankingSelect = () => {
  const localPrefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useQuery({
    queryKey: ['rankingSelect'],
    queryFn: async () => {
      const result = await restClient({ url: `${localPrefix}/rankings/select` });
      return result;
    },
    staleTime: 0,
    cacheTime: 0,
  });
};
